export default __webpack_public_path__ + "static/media/Disturbance.4c771f90.png";